import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

import checkTicket from 'api/requests/ticket/checkTicket';
import editBill from 'api/requests/bill/editBill';

async function fetchTicketByCode({ commit }, code) {
  try {
    const { data } = await checkTicket(axios, code);
    commit('SET_TICKET', data);

    return data;
  } catch (error) {
    if (error?.status === 403) {
      commit('SET_TICKET', { status: 'UNKNOWN' });
    }

    logrocket.logger(error);
    throw new Error(error);
  }
}

// eslint-disable-next-line no-unused-vars
async function saveEditedTicket({ commit }, payload) {
  try {
    const data = await editBill(axios, payload);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchTicketByCode,
  saveEditedTicket,
};
